export const SELECT_TAB = 'SELECT_TAB';
export const changeTab = tab => ({
    type: SELECT_TAB,
    tab
})


// WEBPACK FOOTER //
// ./src/actions/tabs.js